/* nk-shelf-swiper.js v1 (2026-09 黒川)
 * テーマ標準の横スクロール商品グリッド（おすすめ/店舗のおすすめ/ランキング/最近見た）を
 * 新着セクションと同じ Swiper スライダー（PC5列・スマホ2.15列・無限ループ）に変換する。
 * AJAXで後から描画される棚（おすすめ・最近見た）は MutationObserver で拾う。 */
(function () {
  var SELECTOR = '.new-grid.product-grid[data-view="scrollable"], .new-grid.product-grid[data-view="scrollable-5"], .new-grid.product-grid.scrollable-grid--small';

  function enhance(grid) {
    if (!window.Swiper || grid.dataset.nkShelf) return;
    if (grid.classList.contains('visually-invisible')) return;
    if (grid.closest('.cart-recommendations, .site-header__cart, .cart__drawer-form')) return; // カート系はAJAX再描画と相性が悪いため対象外
    var items = Array.prototype.slice.call(grid.children).filter(function (el) { return el.classList.contains('grid-item'); });
    if (items.length < 2) return;
    grid.dataset.nkShelf = '1';
    var isRanking = grid.classList.contains('product-grid-ranking');
    items.forEach(function (it, i) {
      it.classList.add('swiper-slide');
      if (isRanking) { var c = it.querySelector('.grid-item__content'); if (c) c.setAttribute('data-rank', String(i + 1)); }
    });
    grid.classList.add('swiper', 'nk-shelf-swiper');
    grid.classList.remove('scrollable-grid--small');
    grid.removeAttribute('data-view');
    var wrap = document.createElement('div');
    wrap.className = 'swiper-wrapper';
    items.forEach(function (it) { wrap.appendChild(it); });
    grid.appendChild(wrap);
    new Swiper(grid, {
      slidesPerView: 2.15,
      spaceBetween: 10,
      loop: items.length > 5,
      loopAdditionalSlides: 2,
      breakpoints: { 769: { slidesPerView: 5, spaceBetween: 14 } }
    });
  }

  function scan(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll(SELECTOR), enhance);
  }

  function init() {
    scan(document);
    var mo = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches(SELECTOR)) enhance(n); else scan(n);
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        Array.prototype.forEach.call(document.querySelectorAll('.nk-shelf-swiper'), function (el) { if (el.swiper) el.swiper.update(); });
      }, 150);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
